<template>
    <div>
        <div v-if='orderHistories.length > 0' class='orderHistory'>
            <div v-for='order in orderHistories' :key='order.orderCode'>
                <OrderHistoryItem :order='order' @requestOrderDetail='requestOrderDetail'/>
                <hr class='line'/>
            </div>
            <InfiniteLoading v-if='!lastPageFlag' @infinite='requestOrderHistory'/>
        </div>
        <div v-else class='noData'><div class='in'>{{$t('notOrdered')}}</div></div>
        <OrderDetailPopUp/>
    </div>
</template>
<script lang='js'>
import InfiniteLoading from 'vue-infinite-loading'
import OrderDetailPopUp from '@/components/PopUp/OrderDetailPopUp.vue'
import { ORDER_HISTORY_CONTAINER } from '@/utils/EndPoint'
import { NETWORK_ERROR_MESSAGE } from '@/utils/Message'
import { REQ_ORDER_HISTORY, REQ_ORDER_DETAIL } from '@/store/_actions/actionTypes'
import Vue from 'vue'
import OrderHistoryItem from '@/components/Common/OrderHistoryItem.vue'

export default Vue.extend({
  name: ORDER_HISTORY_CONTAINER,
  components: { OrderHistoryItem, InfiniteLoading, OrderDetailPopUp },
  data () {
    return {
      orderHistories: [],
      pageNumber: 1,
      lastPageFlag: true
    }
  },
  created () {
    this.requestOrderHistory()
  },
  methods: {
    requestOrderHistory ($state) {
      this.$store.dispatch(REQ_ORDER_HISTORY, this.pageNumber)
        .then((responsedData) => {
          this.lastPageFlag = responsedData.pageEndFlag

          const orders = responsedData.orderList
          if (orders.length < 1) this.orderHistories = []
          else {
            orders.sort((a, b) => a.ordering - b.ordering)
            this.orderHistories = this.orderHistories.concat(orders)
            this.pageNumber++
            if ($state) $state.loaded()
          }
        }).catch(() => this.toast(this, NETWORK_ERROR_MESSAGE))
    },
    requestOrderDetail (orderCode) {
      this.$store.dispatch(REQ_ORDER_DETAIL, orderCode)
        .then(() => { this.createPopUp('#orderDetailList.cusLayer') })
        .catch(() => this.toast(this, NETWORK_ERROR_MESSAGE))
    }
  }
})
</script>
